<template>
  <div ref="modalbackround" @click.prevent="closeModal($event)" class="modal belowModal" v-show="showFilter">
    <div class="modal-box">
      <div class="modal-header">
        <span class="reset">
          <a href="#" @click.prevent="removeFilters">Alle löschen</a>
        </span>
        <h2>Filter</h2>
        <span class="close" @click.prevent="toggleModal">
          <icon name="close" scale="2"></icon>
        </span>
      </div>
      <!-- <h4 class="subheader">Preisspanne</h4>
      <div class="modal-body btns">
        <button class="btn orange outline active">€</button>
        <button class="btn orange outline">€€</button>
        <button class="btn orange outline">€€€</button>
      </div> -->
      <h4 class="subheader">Kategorie</h4>
      <div class="modal-select">
        <div v-for="category in categories" :class="currentFilter.category.includes(category.uid) ? 'selected' : ''" @click.prevent="toggleCatFilter(category.uid)"><span>{{ category.name }}</span><icon name="check" scale="2"></icon></div>
      </div>
      <!-- <h4 class="subheader">Status</h4> -->
      <!-- <div class="modal-select">
        <div><span>Bio</span><icon name="check" scale="2"></icon></div>
        <div><span>Ökologischer Anbau / Aufzucht</span><icon name="check" scale="2"></icon></div>
        <div class="selected"><span>Ohne Zusatzstoffe</span><icon name="check" scale="2"></icon></div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import { EventBus } from '@/assets/js/event-bus.js'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'modal',
    props: {
      filterCategories: {
        type: Array,
        default: []
      },
      filterFor: {
        type: String,
        default: 'shops'
      }
    },
    mounted () {
      EventBus.$on('toggleFilterModal', () => {
        this.toggleModal()
      })
      EventBus.$on('escKey', () => {
        this.showFilter = false
      })
      this.currentFilter.category = this.filterCategories
    },
    beforeDestroy () {
      EventBus.$off('toggleFilterModal')
      EventBus.$off('escKey')
    },
    data () {
      return {
        showFilter: false,
        currentFilter: {
          category: []
        }
      }
    },
    methods: {
      ...mapActions([
      ]),
      closeModal (e) {
        if (e.target.className === this.$refs.modalbackround.className) {
          this.toggleModal()
        }
      },
      closingModal () {
        this.showFilter = false
        this.iphoneModalsUnset()
      },
      toggleModal () {
        this.showFilter = !this.showFilter
        if (this.showFilter) {
          document.body.classList.add('scrollbar')
          document.getElementById('app').classList.add('overflow-hidden')
        } else {
          document.body.classList.remove('scrollbar')
          document.getElementById('app').classList.remove('overflow-hidden')
        }
      },
      toggleCatFilter (cat) {
        if (!this.currentFilter.category.includes(cat)) {
          this.currentFilter.category.push(cat)
        } else {
          this.currentFilter.category = this.currentFilter.category.filter((category) => {
            return category !== cat
          })
        }
        if (this.filterFor === 'shops') {
          EventBus.$emit('filterShops', this.currentFilter.category)
        } else if (this.filterFor === 'products') {
          EventBus.$emit('filterProducts', this.currentFilter.category)
        }
      },
      removeFilters () {
        this.currentFilter.category = []
        if (this.filterFor === 'shops') {
          EventBus.$emit('filterShops', this.currentFilter.category)
        } else if (this.filterFor === 'products') {
          EventBus.$emit('filterProducts', this.currentFilter.category)
        }
      }
    },
    computed: {
      ...mapGetters({
        categories: 'global_get_categories'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/Filter.vue